import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Heart, Star, Globe } from "lucide-react";
import { EditableText as T } from "@/components/live/EditableText";
import { EditableList } from "@/components/live/EditableList";
import { EditableImage } from "@/components/live/EditableImage";
import { Section } from "@/components/live/Section";

export const VITALS = [
  { key: "age", label: "Age", value: "27" },
  { key: "height", label: "Height", value: "5'6\"" },
  { key: "measurements", label: "Measurements", value: "34B-26-36" },
  { key: "hair", label: "Hair", value: "Dark Brown" },
  { key: "eyes", label: "Eyes", value: "Brown" },
  { key: "ethnicity", label: "Ethnicity", value: "Mixed/Polynesian" },
];

const About = () => {
  const funFacts = [
    "I am the oldest of 6 and the only girl",
    "Arts & crafts are my favorite form of therapy, specifically digital sketching and crocheting, but almost ANY type of art feeds my spirit (and I'm naturally gifted if I do say so myself!)",
    "My first scene EVER was a boy/girl/girl (also my first threesome ever)",
    "I will not turn down a pool or bowling match, under any circumstances, test the theory at your own risk.",
    "I have been playing poker casually (with family and friends) since about 6 years old but have yet to play at a casino table (I prefer slots-- I'm just a girl!!!)",
    "I was always too smart to fall for \"free candy\" but if a van rode around with a \"free ribeye\" sign I can't confidently say I wouldn't get in",
    "Back in 2018 I emailed my hometown's city council a development plan for a Chick-Fil-A to be developed because I was sick of driving 30+ minutes one way for nuggets and Chick-Fil-A sauce. They finally have one as of about two years ago and I'm not saying its because of me....... but my god sister will 100% say exactly that.",
    "I learned how to drive stick before automatic (thanks dad!)",
    "I originally wanted to join the Army Special Forces as a Behavioral Analyst and could have (I scored a 91 on the ASVAB), but by the time I turned 18 life had other plans!",
    "I used to play the flute but quit after my mother refused to let me go to summer band camp (yes, American Pie was her reason. yes, I am being serious.)",
    "I have never finished a single Harry Potter, Lord of the Rings, or Star Wars movie",
    "On the latter, I have seen every single Law & Order: SVU episode there is in existence at least once",
    "I 100% prefer horror, thriller, and action movies over romcoms or drama (again, only daughter of 6)",
    "My go-to karaoke song is \"Picture\" by Kid Rock & Cheryl Crow, and I will more than likely take both parts of the duet for myself",
    "I prefer to make my soups (and certain sauces) from scratch because I think my cooking is the best in the universe honestly."
  ];

  return (
    <div data-testid="about-page">
      {/* Hero Section */}
      <section className="page-header" data-testid="about-header">
        <div className="max-w-4xl mx-auto px-6">
          <T k="about.title" as="h1" className="page-title animate-fade-in">About Kalani</T>
        </div>
      </section>

      {/* Main Bio Section */}
      <Section k="about.section.bio-section" label="bio" className="py-24 px-6 md:px-12 lg:px-24" data-testid="bio-section">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            {/* Image Column */}
            <div className="lg:sticky lg:top-32">
              <div className="image-frame aspect-[3/4] rounded-2xl overflow-hidden">
                <EditableImage k="about.portrait" src="https://customer-assets.emergentagent.com/job_7df16810-7def-4b95-966c-e0aa10481ae2/artifacts/p9i371nl_Facetune_14-08-2025-20-24-13.jpg" alt="Kalani Luana portrait" className="w-full h-full object-cover object-top" />
              </div>
              <T k="about.signature" as="p" className="font-accent text-3xl text-champagne-gold text-center mt-8">With Love, Kalani</T>
            </div>

            {/* Content Column */}
            <div className="space-y-8">
              <div>
                <T k="about.bio.title" as="h2" className="font-heading text-3xl text-charcoal mb-6">Hello, Darling</T>
                <T k="about.bio.p1" as="p" multiline className="font-body text-stone-grey leading-relaxed mb-6">I'm Kalani -- a California girl living in an East Coast world. I was originally born and raised in the East Bay Area, California where I continued to live until my early 20's when I decided I needed a change of scenery. Since then, I have expanded my career as a porn actress and have shot over 20 scenes to date, have you seen any of them?</T>
                <T k="about.bio.p2" as="p" multiline className="font-body text-stone-grey leading-relaxed mb-6">My personality is a beautiful contradiction — I can be bubbly and effervescent one moment, then shift into thoughtful, intimate conversation the next. I believe this duality is what makes our time together so engaging; you never quite know which side of me will emerge, but both are equally authentic.</T>
                <T k="about.bio.p3" as="p" multiline className="font-body text-stone-grey leading-relaxed">When I'm not working on set with productions or knocking out photoshoots with my AMAZING photographers, you might find me exploring restaurants in NYC, learning a new skillset out of pure curiosity, working on one of my MILLIONS of art projects, or indulging in self-care and relaxation. I believe in living to the fullest and trying EVERYTHING at least once; I aim to bring this same passionate, vibrant energy to every connection I make.</T>
              </div>

              <div className="section-divider" />

              {/* Philosophy */}
              <div>
                <h3 className="font-heading text-2xl text-charcoal mb-4 flex items-center gap-3">
                  <Heart className="w-5 h-5 text-champagne-gold" />
                  <T k="about.philosophy.title">My Philosophy</T>
                </h3>
                <T k="about.philosophy.text" as="p" multiline className="font-body text-stone-grey leading-relaxed">I believe that true luxury isn't just about what shines and shimmers — it's about the quality of presence, the depth of conversation, and the authenticity of connection. Every moment we share should feel effortless yet meaningful, spontaneous yet intentional. I'm here to create genuine experiences that linger in your memory long after we've parted ways.</T>
              </div>

              {/* What to Expect */}
              <div>
                <h3 className="font-heading text-2xl text-charcoal mb-4 flex items-center gap-3">
                  <Star className="w-5 h-5 text-champagne-gold" />
                  <T k="about.expect.title">What to Expect</T>
                </h3>
                <T k="about.expect.text" as="p" multiline className="font-body text-stone-grey leading-relaxed">Whether we're sharing an intimate dinner at an upscale restaurant, attending a cultural event, living out your wildest dreams only seen on screens, or enjoying quiet conversation over champagne, you'll find a companion who is fully present, intellectually engaging, and genuinely interested in making our time together exceptional.</T>
              </div>

              {/* Ideal Connections */}
              <div>
                <h3 className="font-heading text-2xl text-charcoal mb-4 flex items-center gap-3">
                  <Globe className="w-5 h-5 text-champagne-gold" />
                  <T k="about.ideal.title">My Ideal Connections</T>
                </h3>
                <T k="about.ideal.text" as="p" multiline className="font-body text-stone-grey leading-relaxed">I connect best with confident, successful individuals who appreciate the art of companionship. Someone who values discretion, respects boundaries, and understands that the most memorable encounters are built on mutual appreciation and genuine chemistry. Age and appearance matter far less to me than character, kindness, and the ability to fully indulge in life's finer experiences.</T>
              </div>
            </div>
          </div>
        </div>
      </Section>

      {/* Vitals Section */}
      <Section k="about.section.vitals-section" label="vitals" className="py-24 px-6 md:px-12 lg:px-24 bg-blush-pink/20" data-testid="vitals-section">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <T k="about.vitals.eyebrow" as="p" className="font-body text-sm tracking-widest uppercase text-champagne-gold mb-4">The Details</T>
            <T k="about.vitals.title" as="h2" className="font-heading text-4xl text-charcoal">At a Glance</T>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {VITALS.map((vital) => (
              <div key={vital.key} className="glass rounded-xl p-6 text-center" data-testid={`vital-${vital.key}`}>
                <p className="font-body text-xs tracking-widest uppercase text-taupe mb-2">{vital.label}</p>
                <T k={`about.vital.${vital.key}`} as="p" className="font-heading text-lg text-charcoal">{vital.value}</T>
              </div>
            ))}
          </div>
        </div>
      </Section>

      {/* Fun Facts Section */}
      <Section k="about.section.fun-facts-section" label="fun facts" className="py-24 px-6 md:px-12 lg:px-24" data-testid="fun-facts-section">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <T k="about.facts.eyebrow" as="p" className="font-body text-sm tracking-widest uppercase text-champagne-gold mb-4">Beyond the Surface</T>
            <T k="about.facts.title" as="h2" className="font-heading text-4xl text-charcoal mb-6">15 Fun (or Funny) Facts About Me</T>
          </div>

          <EditableList k="about.facts" items={funFacts} newItem="A new fun fact about me..." addLabel="Add a fact" className="space-y-4">
            {(fact, index, Field) => (
              <div className="flex items-start gap-4 p-5 glass rounded-xl" data-testid={`fun-fact-${index}`}>
                <span className="w-8 h-8 bg-jade-deep text-white rounded-full flex items-center justify-center flex-shrink-0 font-heading text-sm">
                  {index + 1}
                </span>
                <Field as="p" multiline className="font-body text-stone-grey leading-relaxed" />
              </div>
            )}
          </EditableList>
        </div>
      </Section>

      {/* CTA Section */}
      <Section k="about.section.about-cta" label="about cta" className="py-24 px-6 md:px-12 lg:px-24 bg-jade-deep" data-testid="about-cta">
        <div className="max-w-4xl mx-auto text-center">
          <T k="about.cta.title" as="h2" className="font-heading text-4xl text-ivory mb-6">Intrigued?</T>
          <T k="about.cta.text" as="p" multiline className="font-body text-ivory/80 mb-12 leading-relaxed">I'd love to learn more about you and explore whether we might be a wonderful match. The first step is reviewing my booking guidelines.</T>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/gallery">
              <Button className="bg-white/10 text-ivory border border-ivory/30 hover:bg-white/20 px-8 py-3 rounded-full font-body text-sm tracking-widest uppercase" data-testid="view-gallery-cta">
                <T k="about.cta.gallery">View Gallery</T>
              </Button>
            </Link>
            <Link to="/booking-etiquette">
              <Button className="bg-champagne-gold text-charcoal hover:bg-champagne px-8 py-3 rounded-full font-body text-sm tracking-widest uppercase" data-testid="booking-etiquette-cta">
                <T k="about.cta.etiquette">Booking Etiquette</T>
                <ArrowRight className="ml-2 w-4 h-4" />
              </Button>
            </Link>
          </div>
        </div>
      </Section>
    </div>
  );
};

export default About;
